import React from 'react';
import NavBar from "./NavBar";

const Header = props => {
    return (
        <NavBar/>
    );
};


export default Header;